/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".back-btn[_ngcontent-%COMP%]{position:fixed;top:5rem;left:1rem}@media (max-width:991.98px){.back-btn[_ngcontent-%COMP%]{top:3.5rem}}"];
export { styles as styles };
